

<app-showcase></app-showcase>
<app-bulletin></app-bulletin>
<app-counter></app-counter>
<app-home-about></app-home-about>
<app-programs></app-programs>
<app-events></app-events>
<!-- <app-why></app-why>
<app-vision></app-vision> -->
<app-messages></app-messages>
<app-home-gallery></app-home-gallery>
<app-recruiter></app-recruiter>
<app-luminaries></app-luminaries>
<app-alumni></app-alumni>